import {TransactionService} from "./TransactionService";
import {AxiosResponse} from "axios";
import {IIssuer} from "../models/IIssuer";
import {
    IAllTerminalResponse,
    IBranche,
    IDepartment,
    ILocation,
    IPayerTaxId,
    ITerminal
} from "../models/ITerminal";
import {TerminalsService} from "./TerminalsService";
import {IUserProfile} from "../models/IUserProfile";
import {ClientService} from "./loyalty/ClientService";
import {ILoyaltyMerchant} from "../models/loyalty/IClient";
import {IMPConfigData} from "../models/IMPConfigData";
import {IPromotionCouponConfiguration} from "../models/loyalty/ILoyaltyCoupon";
import {Option} from "../models/Option";
import {SettlementService} from "./SettlementService";
import { saveImages, clearCarouselStorage } from '../utils/db';

let _TaskRuning: boolean = false;
let  _allIssuersFilters: IIssuer[] = [{id:"0000",issuerName:"issuer-0000",acquirerId:"0000",acquirerName:"acquirer-0000",cardType:"0"}];
let  _allTerminals: ITerminal[] = [{serialNumber:undefined,terminalNumber: "0000",clientDocument: "",isPinpad: false,branchId: "0000",departmentId: "0000",locationId: "0000",departmentName:"",branchName:"",locationName:""}];
let  _allBranches: IBranche[] = [{id: "0000",name: "all",locationId: "0000",departmentId: "0000",departmentName:"",locationName:"",fullDesc:"",position:null,fullAddress:"",branchTerminals:[]}];
let  _allPayerTaxIds: IPayerTaxId[] = [{id: "0000",name: "all",branchId: "0000",locationId: "0000",departmentId: "0000"}];
let  _allLocations: ILocation[] = [{id: "0000",name: "all",departmentId: "0000"}];
let  _allDepartments: IDepartment[] = [{id: "0000",name: "all"}];
let currentUser:IUserProfile|null=null;
let _loyaltyEnabled:string="";
let _promotionCouponsEnabled:string="";
let _mpUserConfigData: IMPConfigData = {enabled:false,initialized:false, loaded:false,grantAccessUrl:""};
let _adUser: {loaded:boolean,userMail?:string,roles?:{rolName:string,rolDescription:string}[],fiscalNumbers:{fiscalNumber:number,businessName:string,commerces:{commerceName:string,commerceNumber:number,status:string,presentationGroup:number}[]}[]}={loaded:false,fiscalNumbers:[]};
let _currencies: {currencies:{id:string,name:string}[],loaded:boolean}={currencies:[],loaded:false}
let _supportTicketSections: {sections:{description:string,subSections:string[],additionalFields:string[]}[],loaded:boolean}={sections:[],loaded:false}
let _multiCompanyFiscalDocumentList: {loaded:boolean,companies:{systemId:string,clientName:string,fiscalDocuments:string[]}[]}={companies:[],loaded:false}
let _conciliationData: {loaded:boolean,conciliationEnabled:boolean,disableCalendar:boolean}={conciliationEnabled:false,disableCalendar:false,loaded:false}
let _caratGatewayUrl: {loaded:boolean,url:string}={loaded:false,url:""}


let _allPayerBanks: Option[] = [{ value: "", label: "all", key: "",disabled: false}];
let _allProducts: Option[] = [{ value: "", label: "allFemale", key: "",disabled: false}];
let _allUnfilteredProducts: Option[] = [{ value: "", label: "allFemale", key: "",disabled: false}];
let _allPayerBanksBranchs: Option[] = [{ value: "", label: "allFemale", key: "",disabled: false}];
let _allMerchantDocuments: Option[] = [{ value: "", label: "all", key: "",disabled: false}];
let _allMerchantNumbers: Option[] = [{ value: "", label: "all", key: "",disabled: false}];
let _allWholesalerMerchants: Option[] = [{ value: "", label: "all", key: "",disabled: false}];
let  _allFiscalDocuments: Option[] = [{ value: "", label: "all", key: "",disabled: false}];

const ARG= 1;
const UYU= 2;
const SECTIONS ={
    DashbordRoles: ["Conciliator", "Estadistico", "Minorista", "Usuario de Cliente", "Administrador", "MultiCompany"],
    FinancialRoles: ["Usuario de Cliente","Financial","Minorista","Conciliator","Administrador","MultiCompany"],
    TransactionRoles: ["Operator", "Usuario de Cliente", "Minorista", "Administrador", "MultiCompany"],
    ManagmentRoles: ["Conciliator", "Usuario de Cliente", "Minorista", "Administrador", "MultiCompany"],
    TransferReturnRoles: ["OnlyQr", "Usuario de Cliente", "Minorista", "Administrador", "MultiCompany"],
    DARoles: ["Usuario de Cliente", "AutomaticDebit", "Minorista", "Administrador", "MultiCompany"],
    PosnetAppRoles: ["PosnetAppUser"]
}

export class WebCache {

    public  static initSettlements() {

        if(localStorage._allPayerBanks!=null)
            return;
        SettlementService.getAllPayerBanksAndProductsFromServer().then(function(banksAndProducts){
        //    var gaData:{userId:string,allMerchantNumbers:string[],allWholesalerMerchants:string[],allMerchantDocuments:string[]}={allMerchantNumbers:[],allWholesalerMerchants:[],allMerchantDocuments:[],userId:WebCache.getCurrentUser()==null?"":WebCache.getCurrentUser()?.username+""};
            if(_allPayerBanks.length === 1)
                _allPayerBanks=_allPayerBanks.concat(banksAndProducts.data.banks.sort((x1,x2)=>x1.value>x2.value?1:-1).map(x=>{return {value: x.id, label: x.value, key: x.id,disabled: false}}));
            if(_allProducts.length === 1)
                _allProducts=_allProducts.concat(banksAndProducts.data.products.sort((x1,x2)=>x1.value>x2.value?1:-1).map(x=>{return {value: x.id, label: x.value, key: x.id,disabled: false}}));
            if(_allUnfilteredProducts.length === 1)
                _allUnfilteredProducts=_allUnfilteredProducts.concat(banksAndProducts.data.allProducts.sort((x1,x2)=>x1.value>x2.value?1:-1).map(x=>{return {value: x.id, label: x.value, key: x.id,disabled: false}}));

            if(_allPayerBanksBranchs.length === 1)
                _allPayerBanksBranchs=_allPayerBanksBranchs.concat(banksAndProducts.data.bankBranches.sort((x1,x2)=>x1.value>x2.value?1:-1).map(x=>{return {value: x.id, label: x.value, key: x.id,disabled: false}}));
/*
            function maskRut(value: string) {
                    var res="";
                  for (var i=0;i<value.length;i++){
                      if(i>value.length/3&&i<2*value.length/3)
                          res+="*";
                      else
                          res+=value[i];
                  }
                  return res;
            }*/

            if(_allMerchantDocuments.length === 1){
                _allMerchantDocuments=_allMerchantDocuments.concat(banksAndProducts.data.merchantDocuments.sort((x1,x2)=>x1.value>x2.value?1:-1).map(x=>{return {value: x.id, label: x.value, key: x.id,disabled: false}}));
            //    gaData.allMerchantNumbers=banksAndProducts.data.merchantDocuments.map(x=>maskRut(x.value));
            }
            if(_allMerchantNumbers.length === 1){
                _allMerchantNumbers=_allMerchantNumbers.concat(banksAndProducts.data.merchantNumbers.sort((x1,x2)=>x1.value>x2.value?1:-1).map(x=>{return {value: x.id, label: x.value, key: x.id,disabled: false}}));
            //    gaData.allMerchantNumbers=banksAndProducts.data.merchantNumbers.map(x=>x.value);
            }
            if(_allWholesalerMerchants.length === 1){
                _allWholesalerMerchants=_allWholesalerMerchants.concat(banksAndProducts.data.wholesalerMerchants.sort((x1,x2)=>x1.value>x2.value?1:-1).map(x=>{return {value: x.id, label: x.value, key: x.id,disabled: false}}));
            //    gaData.allWholesalerMerchants=banksAndProducts.data.wholesalerMerchants.map(x=>x.value);
            }


           // ReactGA.set(gaData)
            localStorage.setItem("_allPayerBanks",JSON.stringify(_allPayerBanks));
            localStorage.setItem("_allPayerBanksBranchs",JSON.stringify(_allPayerBanksBranchs));
            localStorage.setItem("_allProducts",JSON.stringify(_allProducts));
            localStorage.setItem("_allUnfilteredProducts",JSON.stringify(_allUnfilteredProducts));

            localStorage.setItem("_allMerchantDocuments",JSON.stringify(_allMerchantDocuments));
            localStorage.setItem("_allMerchantNumbers",JSON.stringify(_allMerchantNumbers));
            localStorage.setItem("_allWholesalerMerchants",JSON.stringify(_allWholesalerMerchants));

        });

    }

    public  static initCache() {
        _allIssuersFilters = [_allIssuersFilters[0]];
        _allTerminals = [_allTerminals[0]];
        _allBranches = [_allBranches[0]];
        _allPayerTaxIds = [_allPayerTaxIds[0]];
        _allLocations = [_allLocations[0]];
        _allDepartments = [_allDepartments[0]];
        _allPayerBanks = [_allPayerBanks[0]];
        _allProducts = [_allProducts[0]];
        _allUnfilteredProducts = [_allUnfilteredProducts[0]];
        _allPayerBanksBranchs =[_allPayerBanksBranchs[0]];
        _allMerchantDocuments =[_allMerchantDocuments[0]];
        _allMerchantNumbers =[_allMerchantNumbers[0]];
        _allWholesalerMerchants =[_allWholesalerMerchants[0]];

        WebCache.initSettlements();

    var promise = new Promise((resolve, reject) => {
                ClientService.getPromotionCouponsConfiguration()
                    .then((response: AxiosResponse<IPromotionCouponConfiguration>) => {
                        if (response.status === 200 && response.data.enabled)
                            _promotionCouponsEnabled = "true";
                        else
                            _promotionCouponsEnabled = "false";
                        localStorage.setItem("_promotionCouponsEnabled", _promotionCouponsEnabled);

                    }).catch(() => localStorage.setItem("_promotionCouponsEnabled", "false")).finally(() => {
                        ClientService.getLoyaltyMerchant()
                            .then((response: AxiosResponse<ILoyaltyMerchant>) => {
                                if (response.status === 200)
                                    _loyaltyEnabled = "true";
                                else
                                    _loyaltyEnabled = "false";
                                localStorage.setItem("_loyaltyEnabled", _loyaltyEnabled);

                            }).catch(() => localStorage.setItem("_loyaltyEnabled", "false")).finally(() => {
                                TransactionService.getAllIssuers().then((response: AxiosResponse<IIssuer[]>) => {
                                    if (response === null || response.data === null || response.data.length === 0) {
                                        return;
                                    }
                                    for (var i in response.data) {
                                        _allIssuersFilters.push(response.data[i]);
                                    }
                                    localStorage.setItem("_allIssuersFilters", JSON.stringify(_allIssuersFilters));
                                    TerminalsService.getAllTerminalsAndLocations().then((response: AxiosResponse<IAllTerminalResponse>) => {
                                        if (response === null || response.data === null) {
                                            return;
                                        }
                                        let ruts: Map<string, string> = new Map<string, string>();
                                        if (response.data.terminals != null) {
                                            for (var i in response.data.terminals) {
                                                _allTerminals.push(response.data.terminals[i]);
                                                if (ruts.get(response.data.terminals[i].clientDocument) == null) {
                                                    _allPayerTaxIds.push({
                                                        id:
                                                            response.data.terminals[i].clientDocument,
                                                        name: response.data.terminals[i].clientDocument,
                                                        branchId: response.data.terminals[i].branchId,
                                                        locationId: response.data.terminals[i].locationId,
                                                        departmentId: response.data.terminals[i].departmentId
                                                    });
                                                    ruts.set(response.data.terminals[i].clientDocument, response.data.terminals[i].clientDocument);
                                                }
                                            }
                                        }
                                        if (response.data.branches != null) {
                                            for (var i in response.data.branches) {
                                                _allBranches.push(response.data.branches[i]);
                                                response.data.branches[i].fullDesc=response.data.branches[i].name
                                            }
                                    }
                                    if(response.data.locations !== null){
                                        for (var i in response.data.locations){
                                            _allLocations.push(response.data.locations[i]);
                                            _allBranches.filter(branch=>branch.locationId==response.data.locations[i].id).forEach(branch=> {branch.locationName=response.data.locations[i].name;
                                                branch.fullDesc+=", "+response.data.locations[i].name; })
                                        }
                                    }
                                    if(response.data.departments !== null){
                                        for (var i in response.data.departments){
                                            _allDepartments.push(response.data.departments[i]);
                                            _allBranches.filter(branch=>branch.departmentId==response.data.departments[i].id).forEach(branch=> {branch.departmentName=response.data.departments[i].name;
                                                branch.fullDesc+=", "+response.data.departments[i].name; })
                                        }
                                    }
                                    WebCache.fetchAllFiscalDocuments().then(function(){
                                        WebCache.updateFeatures().then(function(){
                                            localStorage.setItem("_allPayerTaxIds",JSON.stringify(_allPayerTaxIds));
                                            localStorage.setItem("_allTerminals",JSON.stringify(_allTerminals));
                                            localStorage.setItem("_allBranches",JSON.stringify(_allBranches));
                                            localStorage.setItem("_allDepartments",JSON.stringify(_allDepartments));
                                            localStorage.setItem("_allLocations",JSON.stringify(_allLocations));
                                            resolve("Promise resolved successfully");
                                        });
                                    });
                                }).catch(error => {
                                        console.log('error:', error);
                                        reject(Error(error));
                                    }
                                    );
                                }).catch(error => {
                                    debugger
                                    console.log('error:', error);
                                    reject(Error(error));
                                }
                                );
                            });
                    });
        });
        return promise;
    }

    public  static getAllIssuers() {
        if(_allIssuersFilters.length === 1 && localStorage._allIssuersFilters)
            _allIssuersFilters = JSON.parse(localStorage._allIssuersFilters);
        return _allIssuersFilters;
    };

    public  static getAllDepartments() {
        if(_allDepartments.length === 1 && localStorage._allDepartments)
            _allDepartments = JSON.parse(localStorage._allDepartments);
        return _allDepartments;
    };

    public  static getAllLocations() {
        if(_allLocations.length === 1 && localStorage._allLocations)
            _allLocations = JSON.parse(localStorage._allLocations);
        return _allLocations;
    };

    public  static getAllBranches() {
        if(_allBranches.length === 1 && localStorage._allBranches)
            _allBranches = JSON.parse(localStorage._allBranches);
        return _allBranches;
    };

    public  static getAllPayerTaxIds():IPayerTaxId[] {
        if(_allPayerTaxIds.length === 1 && localStorage._allPayerTaxIds)
            _allPayerTaxIds = JSON.parse(localStorage._allPayerTaxIds);
        // @ts-ignore
        return _allPayerTaxIds.filter(x=>WebCache.getCurrentUser()?.clientDocuments==null||WebCache.getCurrentUser()?.clientDocuments.length==0||WebCache.getCurrentUser()?.clientDocuments.filter(y=>y==x.id).length>0);
    };

    public  static getAllTerminals() {
        if(_allTerminals.length === 1 && localStorage._allTerminals)
            _allTerminals = JSON.parse(localStorage._allTerminals);
        return _allTerminals;
    };

    static getAllRoles() {
        let userLoged = WebCache.getCurrentUser();
        if(userLoged && userLoged.roles && userLoged.countryId===1) {
            return ["Usuario de Cliente","Estadistico","Conciliator","Operator","Financial","OnlyQr","AutomaticDebit","Minorista",/*"DesarrolloQr",*/ "MultiCompany", "Anticipo" ]; //TODO sacar por base
        } else {
            return ["Usuario de Cliente","Estadistico","Conciliator","Operator","Financial","AutomaticDebit",/*"DesarrolloQr",*/"MultiCompany"];//TODO sacar por base
        }
    }

    public static getCurrentUser():IUserProfile|null {
        if(!currentUser) {
            currentUser = localStorage.user ? JSON.parse(localStorage.user) : null;
        }
        return currentUser
    }

    public static isUserARG(): boolean{
        return WebCache.getCurrentUser()?.countryId == ARG;
    }
    public static isUserUYU(): boolean{
        return WebCache.getCurrentUser()?.countryId == UYU;
    }

    public static isUserConciliator(){
        let userLoged = WebCache.getCurrentUser();
        if (userLoged && userLoged.roles) {
            return userLoged.roles.includes("Conciliator");
        }
        return false;
    }

    public static isThereRoleConflict(roles:Array<string>):boolean{
        type SectionKeys = keyof typeof SECTIONS;

        for (const section in SECTIONS) {
            const rolesInSection = SECTIONS[section as SectionKeys];
            const rolesInUser = roles.filter(role => rolesInSection.includes(role));
            if (rolesInUser.length > 1) {
                return true; // Hay más de un rol del usuario en la misma sección
            }
        }
        return false; // No hay conflictos de roles en ninguna sección
    }
    public static isDashboardAllowed() {
        let userLoged = WebCache.getCurrentUser();
        if (userLoged && userLoged.roles) {
            return userLoged.roles.some(role => SECTIONS.DashbordRoles.includes(role));
        }
        return false; 
    }

    public static isPosnetAppUser() {
        let userLoged = WebCache.getCurrentUser();
        if (userLoged && userLoged.roles) {
            return userLoged.roles.some(role => SECTIONS.PosnetAppRoles.includes(role));
        }
        return false; 
    }

    public static isFinancialAllowed(){
        let userLoged = WebCache.getCurrentUser();
        if (userLoged && userLoged.roles) {
            return userLoged.roles.some(role => SECTIONS.FinancialRoles.includes(role));
        }
        return false;
    }
    
    public static isTransactionsAllowed(){
        let userLoged = WebCache.getCurrentUser();
        if (userLoged && userLoged.roles) {
            return userLoged.roles.some(role => SECTIONS.TransactionRoles.includes(role));
        }
        return false;
    }
    public static isManagementAllowed(){
        let userLoged = WebCache.getCurrentUser();
        if(userLoged && userLoged.roles) {
            return userLoged.roles.some(role => SECTIONS.ManagmentRoles.includes(role));
        }
        return false;
    }
    public static isTransferReturnAllowed(){
        let userLoged = WebCache.getCurrentUser();
        if(userLoged && userLoged.roles && userLoged.countryId===1) {
            return userLoged.roles.some(role => SECTIONS.TransferReturnRoles.includes(role));
        }
        return false;
    }

    public static isDevelopmentQrAllowed() {
        let userLoged = WebCache.getCurrentUser();
        if(userLoged && userLoged.roles && userLoged.countryId===1) {
            return userLoged.roles.includes("DesarrolloQr");
        }
        return false;
    }
    
    public static isDaAllowed(){
        let userLoged = WebCache.getCurrentUser();
        if(userLoged && userLoged.roles) {
            if(userLoged.roles.some(role => SECTIONS.DARoles.includes(role))){
                //sacar cuando este el refactor de DA
                if (!_adUser.loaded) {
                    if (localStorage._adUser) {
                        _adUser = JSON.parse(localStorage._adUser);
                        _adUser.loaded = true;
                    }
                }
                return _adUser?.fiscalNumbers.filter(x=>x.commerces.filter(y=>y.status="A").length>0).length>0;
            }
        }
        return false;
    }
    
    static isTerminalUpdateAllowed() {
        let userLoged = WebCache.getCurrentUser();
        if(userLoged && userLoged.roles) {
            return userLoged.roles.find(r => r === "TerminalManager" ) !== null
        }
        return false;
    }

    static getCurrencies(){
        if (!_currencies.loaded) {
            if (localStorage._currencies) {
                _currencies.currencies = JSON.parse(localStorage._currencies);
                _currencies.loaded = true;
            }
        }
        return _currencies?.currencies;
    }
    static getSupportTicketSections():{description:string,subSections:string[],additionalFields:string[]}[]{
        if (!_supportTicketSections.loaded) {
            if (localStorage._supportTicketSections) {
                _supportTicketSections.sections = JSON.parse(localStorage._supportTicketSections);
                _supportTicketSections.loaded = true;
            }
        }
        return _supportTicketSections?.sections;
    }
    static getMultiCompanyFiscalDocumentList():{systemId:string,clientName:string,fiscalDocuments:string[]}[]{
        if (!_multiCompanyFiscalDocumentList.loaded) {
            if (localStorage._multiCompanyFiscalDocumentList) {
                _multiCompanyFiscalDocumentList.companies = JSON.parse(localStorage._multiCompanyFiscalDocumentList);
                _multiCompanyFiscalDocumentList.loaded = true;
            }
        }
        return _multiCompanyFiscalDocumentList?.companies;
    }

    public static GetConciliationData(){
        if (!_conciliationData.loaded) {
            if (localStorage._conciliationData) {
                _conciliationData = JSON.parse(localStorage._conciliationData);
                _conciliationData.loaded = true;
            }
        }
        return _conciliationData;

    }


    static isPromotionCouponsEnabled() {
        
        if (_promotionCouponsEnabled.length === 0) {
            if (localStorage._promotionCouponsEnabled) {
                _promotionCouponsEnabled = localStorage._promotionCouponsEnabled;
            }
            else {
                _promotionCouponsEnabled = "false";
            }
        }

        return _promotionCouponsEnabled === "true";
    }

    static isLoyaltyEnabled() {
        
        if (_loyaltyEnabled.length === 0) {
            if (localStorage._loyaltyEnabled) {
                _loyaltyEnabled = localStorage._loyaltyEnabled;
            }
            else {
                _loyaltyEnabled = "false";
            }
        }

        return _loyaltyEnabled === "true";
    }

    static getMPConfiguration() {
        
        if (!_mpUserConfigData.loaded) {
            if (localStorage._mpUserConfigData) {
                _mpUserConfigData = JSON.parse(localStorage._mpUserConfigData);
                _mpUserConfigData.loaded = true;
            }
        }

        return _mpUserConfigData;
    }

    static getCaratGatewayUrl() {
        if (!_caratGatewayUrl.loaded) {
            if (localStorage._caratGatewayUrl) {
                _caratGatewayUrl = JSON.parse(localStorage._caratGatewayUrl);
                _caratGatewayUrl.loaded = true;
            }
            else {
                _caratGatewayUrl = {loaded:true,url:""};
            }
        }

        return _caratGatewayUrl.url;
    }

    static fetchAllFiscalDocuments() {
        var promise = new Promise((resolve, reject) => {
            TerminalsService.getAllFiscalDocuments().then((response) => {
                if (response.status === 200) {
                    _allFiscalDocuments = _allFiscalDocuments.concat(response.data.map(x=>{return { value: x, label: x, key: x,disabled: false}}));
                    localStorage.setItem("_allFiscalDocuments",JSON.stringify(_allFiscalDocuments));
                }
            }).finally(function(){
                resolve(_allFiscalDocuments)
            })
        });
        return promise;

    }

    static updateFeatures() {
        var responseData:any=null;
        var promise = new Promise((resolve, reject) => {
            TransactionService.getFeatures().then((response) => {
                if (response.status === 200) {
                    var _multiCompanyFiscalDocumentListTmp=[];
                    responseData=response.data;
                    var _conciliationData = {
                        conciliationEnabled:responseData.conciliationEnabled,
                        disableCalendar:responseData.disableCalendar
                    };

                    if(responseData.mPUserDto!=null)
                        _mpUserConfigData = responseData.mPUserDto;
                    else
                        _mpUserConfigData={enabled:false,initialized:false, loaded:false,grantAccessUrl:""};
                    if(responseData.adUserResponseDto!=null&&responseData.adUserResponseDto.fiscalNumbers!="")
                        _adUser = responseData.adUserResponseDto;
                    else
                        _adUser={loaded:false,fiscalNumbers:[]};
                     if(WebCache.isUserUYU()&&responseData.caratGatewayUrl!=null&&responseData.caratGatewayUrl!="")
                        _caratGatewayUrl={loaded:true,url:responseData.caratGatewayUrl};
                    else
                        _caratGatewayUrl={loaded:true,url:""};
                    if(responseData.currencies!=null&&responseData.currencies.length>0)
                        _currencies = responseData.currencies;
                    if(responseData.multiCompanyFiscalDocumentList!=null&&responseData.multiCompanyFiscalDocumentList.length>0)
                        _multiCompanyFiscalDocumentListTmp = responseData.multiCompanyFiscalDocumentList;
                    if(responseData.supportTicketSections!=null&&responseData.supportTicketSections.length>0){
                        let _supportTicketSections = responseData.supportTicketSections;
                        try{

                            if(WebCache.isUserUYU()){
                                let res:{description:string,subSections:string[],additionalFields:string[]}[]=[];
                                for(var i=0;i<_supportTicketSections.length;i++){
                                    if(_supportTicketSections[i].description.toUpperCase().indexOf("QR PCT")>=0)
                                        continue;
                                    res.push(_supportTicketSections[i]);
                                    _supportTicketSections[i].description=_supportTicketSections[i].description.split("CUIT").join("RUT");
                                    for(var j=0;j<_supportTicketSections[i].subSections.length;j++){
                                        _supportTicketSections[i].subSections[j]=_supportTicketSections[i].subSections[j].split("CUIT").join("RUT");
                                    }
                                    for(var j=0;j<_supportTicketSections[i].additionalFields.length;j++){
                                        _supportTicketSections[i].additionalFields[j]=_supportTicketSections[i].additionalFields[j].split("CUIT").join("RUT");
                                    }
                                }
                                _supportTicketSections=res;
                            }
                        }catch (e){console.log(e)}
                        localStorage.setItem("_supportTicketSections",JSON.stringify(_supportTicketSections));
                    }
                    saveImages(response.data?.carousels)
                    // localStorage.setItem("_carousel",JSON.stringify(response.data?.carousels));
                    localStorage.setItem("_transactionStatesCode",JSON.stringify(response.data?.transactionStatesCode));
                    localStorage.setItem("_transactionResponseCode",JSON.stringify(response.data?.transactionResponseCode));
                    localStorage.setItem("_transactionTypesCode",JSON.stringify(response.data?.transactionTypesCode));
                    localStorage.setItem("_mpUserConfigData",JSON.stringify(_mpUserConfigData));
                    localStorage.setItem("_adUser",JSON.stringify(_adUser));
                    localStorage.setItem("_caratGatewayUrl",JSON.stringify(_caratGatewayUrl));
                    localStorage.setItem("_currencies",JSON.stringify(_currencies));
                    localStorage.setItem("_conciliationData",JSON.stringify(_conciliationData));
                    localStorage.setItem("_multiCompanyFiscalDocumentList",JSON.stringify(_multiCompanyFiscalDocumentListTmp));
                    _multiCompanyFiscalDocumentList.loaded=false;
                }
            }).finally(function(){
                resolve(responseData)
            })
        });
        return promise;

    }


    static isTaskRuning = function () { return _TaskRuning }

    static clearCache() {
        localStorage.removeItem("user");
        localStorage.removeItem("_allIssuersFilters");
        localStorage.removeItem("_allTerminals");
        localStorage.removeItem("_allBranches");
        localStorage.removeItem("_allLocations");
        localStorage.removeItem("_allDepartments");
        localStorage.removeItem("_loyaltyEnabled");
        localStorage.removeItem("_promotionCouponsEnabled");
        localStorage.removeItem("_allPayerTaxIds");
        localStorage.removeItem("_mpUserConfigData");
        localStorage.removeItem("_adUser");
        localStorage.removeItem("_caratGatewayUrl");
        localStorage.removeItem("_currencies");
        localStorage.removeItem("_multiCompanyFiscalDocumentList");
        localStorage.removeItem("_conciliationData");
        localStorage.removeItem("_supportTicketSections");
        localStorage.removeItem("_allPayerBanks");
        localStorage.removeItem("_allProducts");
        localStorage.removeItem("_allUnfilteredProducts");
        localStorage.removeItem("_allPayerBanksBranchs");
        localStorage.removeItem("_allMerchantDocuments");
        localStorage.removeItem("_allMerchantNumbers");
        localStorage.removeItem("_allWholesalerMerchants");
        localStorage.removeItem("_allFiscalDocuments");
        localStorage.removeItem("_carousel");
        sessionStorage.removeItem('captchaVerified');
        sessionStorage.removeItem('captchaExpiration');
        if(_multiCompanyFiscalDocumentList)
            _multiCompanyFiscalDocumentList.loaded=false;
        if(_mpUserConfigData)
            _mpUserConfigData.loaded=false;
        if(_adUser)
            _adUser.loaded=false;
        if(_caratGatewayUrl)
            _caratGatewayUrl.loaded=false;
        if(_currencies)
            _currencies.loaded=false;
        if(_supportTicketSections)
            _supportTicketSections.loaded=false;
        if(_conciliationData)
            _conciliationData.loaded=false;
        _allMerchantDocuments=[_allMerchantDocuments[0]];
        currentUser=null;
        clearCarouselStorage();
    }

    static disableTasks() {
        _TaskRuning = false;
    }

    static enableTasks() {
        _TaskRuning = true;
    }

    static showBranchWarnings() {
        let branches=this.getAllBranches();
        if(branches.length === 1)
            return true;
        return this.getAllBranches().filter((branch, index) => index > 0 && (branch.fullAddress === null || branch.fullAddress.length === 0)).length > 0;
    }

    static getAllPayerBanks(includeALl:boolean): Option[] {
        if(_allPayerBanks.length === 1 && localStorage._allPayerBanks) {
            _allPayerBanks = JSON.parse(localStorage._allPayerBanks);
        }
        if(includeALl)
            return WebCache.filterDuplicatedAndSort(_allPayerBanks);
        return WebCache.filterDuplicatedAndSort(_allPayerBanks.filter((x,index)=>index!=0));
    }
    
    static getAllProducts(includeALl:boolean): Option[] {
        if(_allProducts.length === 1 && localStorage._allProducts)
            _allProducts = JSON.parse(localStorage._allProducts);
        if(includeALl)
            return WebCache.filterDuplicatedAndSort(_allProducts);
        return WebCache.filterDuplicatedAndSort(_allProducts.filter((x,index)=>index!=0));
    }
    static getAllUnfilteredProducts(includeALl:boolean): Option[] {
        if(_allUnfilteredProducts.length === 1 && localStorage._allUnfilteredProducts)
            _allUnfilteredProducts = JSON.parse(localStorage._allUnfilteredProducts);
        if(includeALl)
            return WebCache.filterDuplicatedAndSort(_allUnfilteredProducts);
        return WebCache.filterDuplicatedAndSort(_allUnfilteredProducts.filter((x,index)=>index!=0));
    }



/*
    static getAllFiscalDocuments(includeALl:boolean): Option[] {
        if(_allFiscalDocuments.length === 1 && localStorage._allFiscalDocuments)
            _allFiscalDocuments = JSON.parse(localStorage._allFiscalDocuments);
        // @ts-ignore
        if(WebCache.getCurrentUser()!=null&&WebCache.getCurrentUser()?.clientDocuments!=null&&WebCache.getCurrentUser().clientDocuments.length>0)
            // @ts-ignore
            return _allFiscalDocuments.filter(x=>WebCache.getCurrentUser()?.clientDocuments.filter(y=>y==x.label).length>0);
        if(includeALl)
            return _allFiscalDocuments;
        return _allFiscalDocuments.filter((x,index)=>index!=0);
    }*/

    static getAllPayerBankBranches(includeALl:boolean): Option[] {
        if(_allPayerBanksBranchs.length === 1 && localStorage._allPayerBanksBranchs)
            _allPayerBanksBranchs = JSON.parse(localStorage._allPayerBanksBranchs);
        if(includeALl)
            return WebCache.filterDuplicatedAndSort(_allPayerBanksBranchs);
        return WebCache.filterDuplicatedAndSort(_allPayerBanksBranchs.filter((x,index)=>index!=0));
    }

    static getAllMerchantNumbers(includeALl:boolean,includeWholesaler:boolean,includeOnlyWholesaler:boolean = false): Option[] {
        if(_allMerchantNumbers.length === 1 && localStorage._allMerchantNumbers) {
            _allMerchantNumbers = JSON.parse(localStorage._allMerchantNumbers);
        }
        var res=_allMerchantNumbers;
        if(includeOnlyWholesaler)
            res=[_allMerchantDocuments[0]];
        if(includeWholesaler){
            var wholesalerMerchants=this.getAllWholesalerMerchants(false);
            if(wholesalerMerchants.length>0)
                res=res.concat(wholesalerMerchants);
        }
        if(includeALl)
            return WebCache.filterDuplicatedAndSort(res);
        return WebCache.filterDuplicatedAndSort(res.filter((x,index)=>index!=0));
    }

    static getAllWholesalerMerchants(includeALl:boolean): Option[] {
        if(_allWholesalerMerchants.length === 1 && localStorage._allWholesalerMerchants)
            _allWholesalerMerchants = JSON.parse(localStorage._allWholesalerMerchants);
        if(includeALl)
            return WebCache.filterDuplicatedAndSort(_allWholesalerMerchants);
        return WebCache.filterDuplicatedAndSort(_allWholesalerMerchants.filter((x,index)=>index!=0));
    }

    static sortDoc(a:Option,b:Option): number {
        try{
            if(!isNaN(Number(a.label))&&!isNaN(Number(b.label)))
                return Number(a.label) > Number(b.label) ? 1 : -1;
        }catch (e){};
        if(a.label!=null&&((a.label+"").toUpperCase().indexOf("TOD")==0||(a.label+"").toUpperCase().indexOf("ALL")==0))
            return -1;
        if(b.label!=null&&((b.label+"").toUpperCase().indexOf("TOD")==0||(b.label+"").toUpperCase().indexOf("ALL")==0))
            return 1;
        return a.label > b.label ? 1 : -1;
    }
    static filterDuplicatedAndSort(list:Option[]): Option[] {
        var uniqueNames = new Set();
        var res:Option[]=[];
        for(var i in list){
            if(!uniqueNames.has(list[i].value)){
                uniqueNames.add(list[i].value);
                res.push(list[i])
            }
        }
        return res.sort(WebCache.sortDoc);
    }


    static getAllMerchantDocuments(includeALl:boolean,includeWholesaler:boolean,includeOnlyWholesaler:boolean = false): Option[] {
        if(_allMerchantDocuments.length === 1 && localStorage._allMerchantDocuments){
            _allMerchantDocuments = JSON.parse(localStorage._allMerchantDocuments);
        }
        var res=_allMerchantDocuments;
        if(includeOnlyWholesaler)
            res=[_allMerchantDocuments[0]];
        if(includeWholesaler){
            var wholesalerMerchants=this.getAllWholesalerMerchants(false);
            if(wholesalerMerchants.length>0)
                res=res.concat(wholesalerMerchants.map(x=>{return {value:x.key!=null?x.key.split("-")[0].trim():"",disabled:false,key:
                        x.key!=null?x.key.split("-")[0].trim():"",label:x.key!=null?x.key.split("-")[0].trim():""}}));
        }
        // @ts-ignore
        if(WebCache.getCurrentUser()!=null&&WebCache.getCurrentUser()?.clientDocuments!=null&&WebCache.getCurrentUser().clientDocuments.length>0)
            // @ts-ignore
            return WebCache.filterDuplicatedAndSort(res.filter(x=>WebCache.getCurrentUser()?.clientDocuments.filter(y=>y==x.label).length>0));
        if(includeALl)
            return WebCache.filterDuplicatedAndSort(res);
        return WebCache.filterDuplicatedAndSort(res.filter((x,index)=>index!=0));
    }

    static getMultiCompanyFiscalDocumentOptions(): Option[] {
        return WebCache.filterDuplicatedAndSort(this.getMultiCompanyFiscalDocumentList().map(x=>{return {label:x.clientName+" "+x.fiscalDocuments[0],value: x.systemId,key:x.systemId}}));
    }

    public static isAdvancedAllowed(){
        let userLoged = WebCache.getCurrentUser();
        if(userLoged && userLoged.roles) {
            return userLoged.roles.includes("Anticipo");
        }
        return false;
    }
}
